module.exports = {

  clientId: 13,
  "default_login" : "",
  "default_pass" : "",
  hexon: true,
  vehicle_details_show_special_button: true,
  hide_fix_damages: true,
  hide_picked_up: true,
  hide_sell_with_license_plate: true,
  hide_sales_preference: true,
  disable_SIRV:false,
  enable_hemex : true,
  hide_transport_card: true,
  hide_website_card : true,
  // hide_inspection_card : true,
  hide_photos_card : true,
  hide_other_buttons : true,
  hide_inspection_filter : true,
  hide_mandatory_field_outgoing_order : true,
  hide_transaction_result : true,
  hide_products : true ,
  hide_bpm_card : true ,
  hide_task_card : true,
  hide_rdw_card : true,
  hide_payment_filter : true,
  hide_company_structure_card: true,
  hide_counterscard: true,
  user_filter_list : [
    {
      label:'admin',
      value:1
    }
  ],

  google_maps_api_key: "AIzaSyAzQOd9IQpDtlFtrk8Cb_imsvHfeF-yDMk",

  requiredFieldsPersonal: [
    "empty_weight",
    "number_of_seats",
    "interior_color",
    "interior_type",
    "power_axle",
    "trailer_with_brakes",
    "middleaxle_trailer_with_brakes",
    "mileage",
    "brand_name",
    "model_name",
    "model_info",
    "date_first_allowance",
    "body_type",
    "base_color",
    "transmission_type",
    "fuel_type",
    "co2_rdw",
    "euro_class",
    "verbruik",
    "energy_label",
  ],

  requiredFieldsCommercial : [
    "number_of_seats",
    "power_axle",
    "trailer_with_brakes",
    "middleaxle_trailer_with_brakes",
    "technical_max_weight_vehicle",
    "mileage",
    "brand_name",
    "model_name",
    "model_info",
    "date_first_allowance",
    "body_type",
    "base_color",
    "transmission_type",
    "fuel_type",
    "co2_rdw",
    "euro_class",
    "verbruik",
    "energy_label",
  ],

  requiredFieldsElectric :[
    "battery_capacity",
    "consumption_KwH",
    "max_chargingspeed_DC",
  ],

  optionsList_inspection : [
          { title: 'Exterieur',    },

          'Lichtmetalen velgen',
          'Metallic lak',
          'Panoramadak',
          'Schuif-kanteldak',
          'Parkeersensoren',
          'Achteruitrijcamera',
          'Trekhaak met vaste kogel',
          'Trekhaak met afneembare kogel',
          'Trekhaak wegklapbare kogel',
          'Luchtvering',
          'Xenon koplampen',
          'LED verlichting',


              { title: 'Interieur',    },
      'Airco',
      'climate control',
      'Stoelverwarming',
      'Head-up display',
      'Android auto - Apple Carplay',
      'Navigatiesysteem',
      'Lederen bekleding',
      'Cruise control',
      'Cruise control adaptief',

      { title: 'Overig',    },
      // 'has_instruction_book',
      // 'has_maintenance_book',
      // 'has_digital_maintenance',
      'has_back_cover',
      'has_charge_cable',
      ],

  photo_layers: {
    //put these images in the same directory as where /documents are stored
    top: ['top1.png'],
    bottom: ['bottom1.png', 'bottom2.png', 'bottom3.png'],
  },

  inspection_impressions: true,
  inspection_attention_incidents: true,
  inspection_v2: true,

  auth_flow: 'AZURE',
  azure_client_id: '1015e878-af3b-43f2-9582-6adfcd092e85',
  azure_authority: 'https://hiltermannleasevindat.b2clogin.com/hiltermannleasevindat.onmicrosoft.com/B2C_1_SignUpAndSignIn',
  azure_authority_domain: 'hiltermannleasevindat.b2clogin.com',
  azure_domain: 'hiltermannleasevindat.onmicrosoft.com',
  azure_auth_policy: 'B2C_1_SignUpAndSignIn',
  azure_redirect_uri: '/',
  azure_logout_redirect_uri: 'https://hiltermann.test.vindat.nl',

}
